import React, { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { ModalTitle } from 'app/common/modals/title'
import { H1, H3 } from 'app/common/typography'
import { colors } from 'shared/assets/styles'
import styled from 'styled-components'
import { ButtonMedium } from 'app/assets/styles'
import { media } from 'app/assets/styles'
import { toSrcSet } from 'shared/utils'
import { Picture } from 'react-responsive-picture'
import tuto_kingdom_1 from 'shared/assets/images/kingdom-tutorial/tuto_kingdom_1_1x.webp'
import tuto_kingdom_2 from 'shared/assets/images/kingdom-tutorial/tuto_kingdom_2_1x.webp'
import tuto_kingdom_3 from 'shared/assets/images/kingdom-tutorial/tuto_kingdom_3_1x.webp'
import tuto_kingdom_4 from 'shared/assets/images/kingdom-tutorial/tuto_kingdom_4_1x.webp'
import tuto_kingdom_1_2x from 'shared/assets/images/kingdom-tutorial/tuto_kingdom_1_2x.webp'
import tuto_kingdom_2_2x from 'shared/assets/images/kingdom-tutorial/tuto_kingdom_2_2x.webp'
import tuto_kingdom_3_2x from 'shared/assets/images/kingdom-tutorial/tuto_kingdom_3_2x.webp'
import tuto_kingdom_4_2x from 'shared/assets/images/kingdom-tutorial/tuto_kingdom_4_2x.webp'
import tuto_kingdom_1_3x from 'shared/assets/images/kingdom-tutorial/tuto_kingdom_1_3x.webp'
import tuto_kingdom_2_3x from 'shared/assets/images/kingdom-tutorial/tuto_kingdom_2_3x.webp'
import tuto_kingdom_3_3x from 'shared/assets/images/kingdom-tutorial/tuto_kingdom_3_3x.webp'
import tuto_kingdom_4_3x from 'shared/assets/images/kingdom-tutorial/tuto_kingdom_4_3x.webp'
import new_tuto_kingdom_1 from 'shared/assets/images/kingdom-tutorial/new_kingdom_1_1x.webp'
import new_tuto_kingdom_1_2x from 'shared/assets/images/kingdom-tutorial/new_kingdom_1_2x.webp'
import new_tuto_kingdom_1_3x from 'shared/assets/images/kingdom-tutorial/new_kingdom_1_3x.webp'
import new_tuto_kingdom_2 from 'shared/assets/images/kingdom-tutorial/new_kingdom_2_1x.webp'
import new_tuto_kingdom_2_2x from 'shared/assets/images/kingdom-tutorial/new_kingdom_2_2x.webp'
import new_tuto_kingdom_2_3x from 'shared/assets/images/kingdom-tutorial/new_kingdom_2_3x.webp'
import new_tuto_kingdom_3 from 'shared/assets/images/kingdom-tutorial/new_kingdom_3_1x.webp'
import new_tuto_kingdom_3_2x from 'shared/assets/images/kingdom-tutorial/new_kingdom_3_2x.webp'
import new_tuto_kingdom_3_3x from 'shared/assets/images/kingdom-tutorial/new_kingdom_3_3x.webp'
import new_tuto_kingdom_4 from 'shared/assets/images/kingdom-tutorial/new_kingdom_4_1x.webp'
import new_tuto_kingdom_4_2x from 'shared/assets/images/kingdom-tutorial/new_kingdom_4_2x.webp'
import new_tuto_kingdom_4_3x from 'shared/assets/images/kingdom-tutorial/new_kingdom_4_3x.webp'
import { Chevron } from 'app/assets/icons'

const { lightGrey, yellow } = colors

type Props = {
    handleClose: () => void,
    isActiveNewKingdomAssets: boolean
}

const KingdomTutorialModal = (props: Props) => {
    const { handleClose, isActiveNewKingdomAssets } = props
    const [activeSlide, setActiveSlide] = useState(0)

    const images = [
        [tuto_kingdom_1, tuto_kingdom_1_2x, tuto_kingdom_1_3x],
        [tuto_kingdom_2, tuto_kingdom_2_2x, tuto_kingdom_2_3x],
        [tuto_kingdom_3, tuto_kingdom_3_2x, tuto_kingdom_3_3x],
        [tuto_kingdom_4, tuto_kingdom_4_2x, tuto_kingdom_4_3x]
    ]

    const newImages = [
        [new_tuto_kingdom_1, new_tuto_kingdom_1_2x, new_tuto_kingdom_1_3x],
        [new_tuto_kingdom_2, new_tuto_kingdom_2_2x, new_tuto_kingdom_2_3x],
        [new_tuto_kingdom_3, new_tuto_kingdom_3_2x, new_tuto_kingdom_3_3x],
        [new_tuto_kingdom_4, new_tuto_kingdom_4_2x, new_tuto_kingdom_4_3x]
    ]

    const renderItem = () => {
        return (
            <StyledPicture
                sources={[
                    {
                        srcSet: toSrcSet(
                            isActiveNewKingdomAssets
                                ? newImages[activeSlide]
                                : images[activeSlide]
                        )
                    }
                ]}
            />
        )
    }

    const renderDots = images.map((image, index) => {
        return (
            <Dot
                key={index}
                color={activeSlide === index ? yellow : lightGrey}
                onClick={() => setActiveSlide(index)}
            />
        )
    })

    return (
        <Container>
            <ModalTitle
                center
                handleClose={handleClose}
                titleNode={
                    <div>
                        <FormattedMessage id="kingdom.dashboard.title">
                            {(text: string) => <H1 center>{text}</H1>}
                        </FormattedMessage>
                        <FormattedMessage id="help.kingdom">
                            {(text: string) => (
                                <H3 center color={yellow}>
                                    {text}
                                </H3>
                            )}
                        </FormattedMessage>
                    </div>
                }
            />
            <Content>
                <SwipeContainer>
                    <ChevronContainer>
                        <Chevron
                            color={activeSlide !== 0 ? 'black' : 'transparent'}
                            direction="left"
                            size={24}
                            onClick={() =>
                                activeSlide !== 0 &&
                                setActiveSlide(activeSlide - 1)
                            }
                        />
                    </ChevronContainer>
                    {renderItem()}
                    <ChevronContainer>
                        <Chevron
                            color={
                                activeSlide !== images.length - 1
                                    ? 'black'
                                    : 'transparent'
                            }
                            size={24}
                            onClick={() =>
                                activeSlide !== images.length - 1 &&
                                setActiveSlide(activeSlide + 1)
                            }
                        />
                    </ChevronContainer>
                </SwipeContainer>
                <DotsContainer>{renderDots}</DotsContainer>
                <StyledButtonMedium
                    onClick={handleClose}
                    background={yellow}
                    disabled={activeSlide !== images.length - 1}>
                    <FormattedMessage id="kingdom.points.tuto.cta" />
                </StyledButtonMedium>
            </Content>
        </Container>
    )
}

const Container = styled.div`
    padding: 20px;
    ${media.medium`
        padding: 40px;
    `};
`

const Content = styled.div`
    display: flex;
    flex-direction: column;
`

const SwipeContainer = styled.div`
    display: flex;
    align-items: center;
`

const DotsContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 20px 0;
`

const Dot = styled.div`
    width:12px
    height: 12px;
    border-radius: 13px;
    margin-right: 10px;
     background-color: ${props => props.color};
`

const ChevronContainer = styled.div`
    height: 24px;
    width: 24px;
    margin: 0 10px;
    ${media.medium`
        margin: 0 20px;
    `};
`

const StyledButtonMedium = styled(ButtonMedium)`
    align-self: center;
    margin: 20px 0;
    border: none;
    &:disabled {
        opacity: 0.5;
    }
`

const StyledPicture = styled(Picture)`
    width: 100%;
    height: 100%;
    margin: 40px 0;
`

export { KingdomTutorialModal }
